import type { ReactNode } from 'react';
import { Box } from '@mui/material';

import { Sidebar } from '../Home/Sidebar';
import { SIDEBAR_SECTIONS } from '../Home/sidebarSections';
import { TopBar, type Crumb } from '../IndividualPlan/TopBar';
import { COLORS } from '../IndividualPlan/tokens';
import { ContentColumn } from './program-evaluation.styled';
import { PE_ROUTE } from './listKeys';
import { HEIGHT_BELOW_BARS } from '../../core/bannerOffset';

export function ProgramEvaluationShell({ crumbs, children }: { crumbs: Crumb[]; children: ReactNode }) {
  const trail: Crumb[] = [
    { label: 'Reports', to: '/reports' },
    crumbs.length === 0 ? { label: 'Program Evaluation' } : { label: 'Program Evaluation', to: PE_ROUTE },
    ...crumbs,
  ];
  return (
    <Box sx={{ display: 'flex', minHeight: HEIGHT_BELOW_BARS, bgcolor: COLORS.bg }}>
      <Sidebar sections={SIDEBAR_SECTIONS} activeId="reports" />
      <Box component="main" sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
        <TopBar crumbs={trail} />
        <Box sx={{ flex: 1, py: 4 }}>
          <ContentColumn>{children}</ContentColumn>
        </Box>
      </Box>
    </Box>
  );
}
